import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Sectors from './pages/Sectors'
import News from './pages/News'
import Pricing from './pages/Pricing'
import Discover from './pages/Discover'
import Detail from './pages/Detail'

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Sectors />} />
        <Route path="/news" element={<News />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/sector/:id" element={<Detail />} />
      </Routes>
    </Layout>
  )
}
